import React from 'react';

interface WorkflowDiagramProps {
    variant?: 'full' | 'compact';
    className?: string;
}

const WorkflowDiagram: React.FC<WorkflowDiagramProps> = ({ variant = 'full', className = '' }) => {
    const steps = [
        { label: 'Raw Data', sublabel: 'Wearables + Testing' },
        { label: 'Filter', sublabel: 'Quality Control' },
        { label: 'Model', sublabel: 'CGM Engine' },
        { label: 'Alert', sublabel: 'Readiness Flags' },
        { label: 'Report', sublabel: 'Daily Brief' },
    ];

    const compact = variant === 'compact';
    const boxW = compact ? 70 : 90;
    const boxH = compact ? 44 : 54;
    const gap = compact ? 16 : 24;
    const totalW = steps.length * boxW + (steps.length - 1) * gap;
    const viewW = totalW + 40;
    const viewH = compact ? 70 : 80;

    return (
        <div className={`w-full overflow-hidden ${className}`}>
            <svg viewBox={`0 0 ${viewW} ${viewH}`} className="w-full h-auto" fill="none">
                {steps.map((step, i) => {
                    const x = 20 + i * (boxW + gap);
                    const centerY = viewH / 2;
                    const topY = centerY - boxH / 2;

                    return (
                        <g key={step.label}>
                            {/* Box */}
                            <rect
                                x={x}
                                y={topY}
                                width={boxW}
                                height={boxH}
                                stroke="rgba(255,255,255,0.3)"
                                strokeWidth="1"
                            />
                            <text
                                x={x + boxW / 2}
                                y={centerY - (compact ? 2 : 4)}
                                textAnchor="middle"
                                fill="white"
                                fontSize={compact ? 9 : 11}
                                fontWeight="600"
                                fontFamily="Inter, sans-serif"
                            >
                                {step.label}
                            </text>
                            <text
                                x={x + boxW / 2}
                                y={centerY + (compact ? 9 : 10)}
                                textAnchor="middle"
                                fill="rgba(255,255,255,0.4)"
                                fontSize={compact ? 7 : 8}
                                fontFamily="Inter, sans-serif"
                            >
                                {step.sublabel}
                            </text>

                            {/* Arrow to next */}
                            {i < steps.length - 1 && (
                                <g>
                                    <line
                                        x1={x + boxW}
                                        y1={centerY}
                                        x2={x + boxW + gap}
                                        y2={centerY}
                                        stroke="rgba(255,255,255,0.2)"
                                        strokeWidth="1"
                                        strokeDasharray="3 3"
                                        className="animate-dash-flow"
                                    />
                                    <polygon
                                        points={`${x + boxW + gap - 4},${centerY - 3} ${x + boxW + gap},${centerY} ${x + boxW + gap - 4},${centerY + 3}`}
                                        fill="rgba(255,255,255,0.3)"
                                    />
                                </g>
                            )}
                        </g>
                    );
                })}
            </svg>
        </div>
    );
};

export default WorkflowDiagram;
